import * as widgetActions from '../Widget/actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const alreadyCancelledActions = [];
const alreadyChosenActions = [];
const eventMappings = {};
eventMappings[widgetActions.SET_ACTIVE_ACTION_FROM_ACTION_CHOICE] = [trackActionChosen];
eventMappings[widgetActions.ACTION_CHOICE_CANCEL_ACTION] = [trackActionCancelled];

export default function trackActionChoiceCard(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackActionChosen(state) {
    if (alreadyChosenActions[state.widget.activeAction.identifier] != null) return;
    alreadyChosenActions[state.widget.activeAction.identifier] = true;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_INITIATED, {
        ...state.widget,
        action: state.widget.activeAction
    });
    apiTracking.trackActionChosen(state);
}

function trackActionCancelled(state) {
    if (alreadyChosenActions[state.widget.activeAction.identifier] != null) return;
    alreadyCancelledActions[state.widget.activeAction.identifier] = true;
    const actionCancelTime = state.widget.cancelTime;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: actionCancelTime
    });
    apiTracking.trackCancelAction(state, actionCancelTime);
}
